import {createEvent, type Emitter, type Listener} from "react-event-hook";

export interface MessageSentEventPayload {
    /**
     * The threadID for which the message was sent.
     */
    threadID: string;
}

interface Event {
    /**
     * Listen for the message sent event.
     */
    useMessageSentListener: Listener<MessageSentEventPayload>;
    /**
     * Emit the message sent event.
     *
     * This event is raised by the askAIGuide handler to signal that
     * a message has been sent to the AI guide.
     */
    emitMessageSent: Emitter<MessageSentEventPayload>;
}

export const {useMessageSentListener, emitMessageSent} = createEvent(
    "message-sent",
)() as Event;
